export const ANALYTICS_DEBUG_COOKIE = "argonaut_analytics_debug";

export const isDebug = (): boolean => {
  const cookies = document.cookie.split(";");
  let isDebugMode = false;

  for (const cookie of cookies) {
    const [cookieKey, cookieValue] = cookie.trim().split("=");
    if (cookieKey === ANALYTICS_DEBUG_COOKIE) {
      isDebugMode = cookieValue === "true";
      return isDebugMode;
    }
  }
  return isDebugMode;
};

export const debugLog = (
  message: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ...args: any[]
) => {
  const debugMode = isDebug();
  if (debugMode) {
    console.log(`@rea-argonaut/analytics/debug - ${message}`, ...args);
  }
};
